// Helpers for the admin Billing access screen (pure, unit-tested). (Not
// named billingAccess.js: macOS file names ignore case, so it would be the
// same file as BillingAccess.js.)

const num = (n) => Number(n || 0).toLocaleString();
const day = (d) => new Date(d).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });

// grantLive: the grant applies now (no end date, or it ends later).
export function grantLive(grant, now = new Date()) {
  return !!grant && (!grant.expires_at || new Date(grant.expires_at) > now);
}

// grantSummary says what a grant allows, in a line.
export function grantSummary(grant, now = new Date()) {
  if (!grant) return "";
  const limits = [
    grant.included_emails > 0 ? `${num(grant.included_emails)} emails a month` : "unlimited emails",
    grant.included_contacts > 0 ? `${num(grant.included_contacts)} contacts` : "unlimited contacts",
  ].join(", ");
  if (!grant.expires_at) return `${limits}, no end date`;
  return grantLive(grant, now) ? `${limits}, until ${day(grant.expires_at)}` : `Ended ${day(grant.expires_at)}`;
}

// grantRequest turns the form into the API body. endsOn is "YYYY-MM-DD" (or
// empty: no end): access lasts through the end of that day, local time.
export function grantRequest({ emails, contacts, endsOn, note }) {
  let expires = null;
  if (endsOn) {
    const [y, m, d] = endsOn.split("-").map(Number);
    expires = new Date(y, m - 1, d + 1).toISOString();
  }
  return {
    included_emails: Math.max(0, Math.round(Number(emails) || 0)),
    included_contacts: Math.max(0, Math.round(Number(contacts) || 0)),
    expires_at: expires,
    note: note || "",
  };
}

// grantForm fills the form from an existing grant (or blank for a new one).
export function grantForm(grant) {
  if (!grant) return { emails: 0, contacts: 0, endsOn: "", note: "" };
  let endsOn = "";
  if (grant.expires_at) {
    // Stored as the start of the day after; show the last day of access.
    const last = new Date(new Date(grant.expires_at).getTime() - 1);
    const pad = (n) => String(n).padStart(2, "0");
    endsOn = `${last.getFullYear()}-${pad(last.getMonth() + 1)}-${pad(last.getDate())}`;
  }
  return { emails: grant.included_emails || 0, contacts: grant.included_contacts || 0, endsOn, note: grant.note || "" };
}
